import { Component, OnInit, Input, OnChanges } from '@angular/core'
import { IVehicle, ITrailer } from 'app/vehicles/vehicles.interfaces'
import { FormGroup, FormControl } from '@angular/forms'
import { SelectItem } from 'app/shared/select-field/select.model';
import { distinctUntilChangedDeep } from 'app/shared/utils';

@Component({
    selector: 'sbw-vehicles-selector',
    templateUrl: './vehicles-selector.component.html',
    styleUrls: ['./vehicles-selector.component.css']
})
export class VehiclesSelectorComponent implements OnInit, OnChanges {

    @Input() vehicles: IVehicle[] = []
    @Input() trailers: ITrailer[] = []
    @Input() supportMultiple = false
    @Input() formVehicleSelector: FormGroup
    @Input() errorVehicle = false
    @Input() errorTrailer = false

    public showSupportMultipleSelector = true;
    public allowedTrailers: ITrailer[] = []

    public vehicleTypeControl: FormControl
    public trailerTypeControl: FormControl

    get vehicleControl(): FormControl { return <FormControl>this.formVehicleSelector.get('vehicle') }
    get trailerControl(): FormControl { return <FormControl>this.formVehicleSelector.get('trailer') }
    get vehicleCountControl(): FormControl { return <FormControl>this.formVehicleSelector.get('count') }

    get vehicle(): IVehicle { return <IVehicle>this.vehicleControl.value }
    get trailer(): ITrailer { return <ITrailer>this.trailerControl.value }

    get isVehicleSelected(): boolean { return !!this.vehicleControl.value.id && this.vehicleControl.value.id !== '00000000-0000-0000-0000-000000000000' }

    get vehicleItems(): SelectItem[] { return this.vehicles.map(v => <SelectItem>{ value: v.type, text: v.name }) }
    get trailerItems(): SelectItem[] { return this.allowedTrailers.map(t => <SelectItem>{ value: t.type, text: t.name }) }
    get vehicleCountItems(): SelectItem[] {
        let vehicleCountArray = new Array(9).fill(0).map((_, i) => ({ value: i + 1, text: (i + 1).toString() }))
        return vehicleCountArray
    }

    ngOnInit() {
        this.initForm()
        this.vehicleTrailerChanged()
    }

    ngOnChanges() {
        this.vehicleTrailerChanged()
    }

    private initForm() {

        // Internal formcontrol for vehicle and trailer
        this.vehicleTypeControl = new FormControl(this.vehicle ? this.vehicle.type : "")
        this.trailerTypeControl = new FormControl(this.trailer ? this.trailer.type : "")

        // Listen for vehicle & trailer from outer component
        this.formVehicleSelector.valueChanges
            .pipe(distinctUntilChangedDeep())
            .subscribe(f => {
                if (f.vehicle) this.vehicleTypeControl.setValue(f.vehicle.type)
                if (f.trailer) this.trailerTypeControl.setValue(f.trailer.type)
            })

        // Listen for vehicle & trailer changes from intern component
        this.vehicleTypeControl.valueChanges.subscribe(() => this.vehicleTrailerChanged())
        this.trailerTypeControl.valueChanges.subscribe(() => this.vehicleTrailerChanged())
    }

    private vehicleTrailerChanged() {
        if (!this.vehicleTypeControl) return
        let selectedVehicle = this.vehicles.find(v => v.type == this.vehicleTypeControl.value)
        if (!selectedVehicle) { return }

        this.vehicleControl.setValue(selectedVehicle)

        let trailerIds = selectedVehicle.trailers
        this.allowedTrailers = trailerIds ? this.trailers.filter(f => !f.id || trailerIds.indexOf(f.id) !== -1) : []

        let selectedTrailer = this.trailers.find(t => t.type == this.trailerTypeControl.value)
        if (!this.allowedTrailers.find(t => t == selectedTrailer))
            this.trailerControl.setValue(this.allowedTrailers[0])
        else
            this.trailerControl.setValue(selectedTrailer)
    }
}
